import React from "react";
import {FixBenefitsProps} from "@/elements-react/fix-benefits";

export const FixBenefitsDefault: React.FC<FixBenefitsProps> = () => {
   return(<></>);
};
